module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_3.db965c51.png";